const map = {
	"./1.webp": 7472,
	"./2.webp": 2141,
	"./3.webp": 7202,
	"./4.webp": 3103,
	"./5.webp": 8812,
	"./6.webp": 5673,
	"./7.webp": 1166
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2194;